import { render, staticRenderFns } from "./dong9.vue?vue&type=template&id=f9876650&scoped=true&"
import script from "./dong9.vue?vue&type=script&lang=js&"
export * from "./dong9.vue?vue&type=script&lang=js&"
import style0 from "./dong9.vue?vue&type=style&index=0&id=f9876650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9876650",
  null
  
)

export default component.exports